import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {map} from 'rxjs';
import * as AuthActions from '../store/actions/auth.action';
import {detectCrmParams} from './integrations/integration.helper';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})


export class RouterService {
  constructor(
    private _activatedRoute: ActivatedRoute, 
    private _storageService: StorageService,
    private _router: Router,
    private _store$: Store 
  ) { }

  async getQueryParams(): Promise<string> {
    return new Promise((resolve) => {
      this._activatedRoute.queryParams
        .pipe(
          map((params) => {
            return new URLSearchParams(params).toString();
          })
        )
        .subscribe((queryString) => {
          resolve(queryString);
        });
    });
  }



  async parseQueryParams() {
    const queryString = await this.getQueryParams();
    return queryString.split('&').reduce((acc, pair) => {
      const [key, value] = pair.split('=');
      acc[decodeURIComponent(key)] = decodeURIComponent(value);
      return acc;
    }, {} as { [key: string]: string });
  }




  /**
   * Build CRM Query Params If Its Store In LocalStorage
   * @param crmData 
   * @returns 
   */
  buildCrmQueryParams(crmData: { [key: string]: string | number | boolean | Date } ){
    const queryParams: { [key: string]: string | number | boolean | Date } = {};
    Object.keys(crmData).forEach((key: string) => {
        queryParams[key] = crmData[key];
    });
    return queryParams;
  }




  /**
   * Redirect Crm User To Route
   * @param url 
   */
  redirectCrmUserToRoute(url: string):void{
    let crmData = {};
    if(this._storageService.getItem('crmData')){
      crmData = JSON.parse(this._storageService.getItem('crmData'));
    }
    const queryParams = this.buildCrmQueryParams(crmData);
    this._router.navigate([url], { queryParams });
  }



  setCrmParams(){
    const params = this.getQueryParamsFromUrl(window.location.href);
    if(detectCrmParams(params)){
      this._store$.dispatch(AuthActions.loadCrmData(params));
      this._storageService.addItem('crmData', params);
      this._storageService.addItem('is_crm_user', 1);
    }
  }



  getQueryParamsFromUrl(url) {
    const queryParams = {};
    const queryString = url.split('?')[1];
    if (queryString) {
      const pairs = queryString.split('&');
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
      });
    }
    return queryParams;
  }
  
}
